import { API_URL } from './settings';
import axios from 'axios';

axios.interceptors.request.use(
	config => {
		if (!config.headers.Authorization && typeof localStorage !== "undefined") {
			const token = localStorage.getItem('token');
			if (token) {
				config.headers['Authorization'] = token;
			}
		}
		return config;
	},
	error => {
		Promise.reject(error)
	}
);

export const addUploadFeature = requestHandler => (type, resource, params) => {
	if (type === 'CREATE' || type === 'UPDATE') {
		if (params.data.pictures) {
			return requestHandler(type, resource, params)
			.then(response => {
				const pictures = params.data.pictures;
				for (const picture of pictures) {
					if (picture.id) {
						axios.put(`${API_URL}/pictures/${picture.id}`, picture);
					}
					else {
						if (!(picture.picture_file.rawFile instanceof File)) {
							return Promise.reject('Error: Not a file...');
						}

						const formData = new FormData();
						if (picture.title) {
							formData.append('title', picture.title);
						}
						if (picture.description) {
							formData.append('description', picture.description);
						}
						if (picture.copyright) {
							formData.append('copyright', picture.copyright);
						}
						formData.append('picture_file', picture.picture_file.rawFile);

						axios.post(`${API_URL}/${resource}/${response.data.id}/pictures`, formData, {
							headers: {
								'content-type': 'multipart/form-data'
							}
						});
					}
				}

				if (params.data.delete_pictures_ids) {
					for (const id of params.data.delete_pictures_ids) {
						axios.delete(`${API_URL}/pictures/${id}`);
					}
				}

				return response;
			});
		}

		if (resource === 'pictures' && type === 'CREATE') {
			if (!(params.data.picture_file.rawFile instanceof File)) {
				return Promise.reject('Error: Not a file...');
			}

			const formData = new FormData();
			if (params.data.title) {
				formData.append('title', params.data.title);
			}
			if (params.data.description) {
				formData.append('description', params.data.description);
			}
			if (params.data.copyright) {
				formData.append('copyright', params.data.copyright);
			}
			if (params.data.poi_id) {
				formData.append('poi_id', params.data.poi_id);
			}
			if (params.data.story_id) {
				formData.append('story_id', params.data.story_id);
			}
			if (params.data.themed_route_id) {
				formData.append('themed_route_id', params.data.themed_route_id);
			}
			if (params.data.event_id) {
				formData.append('event_id', params.data.event_id);
			}
			formData.append('picture_file', params.data.picture_file.rawFile);

			return axios.post(`${API_URL}/pictures`, formData, {
				headers: {
					'content-type': 'multipart/form-data'
				}
			});
		}

		if (resource === 'partners' && (type === 'CREATE' || type === 'UPDATE')) {
			if (params.data?.logo_file && !(params.data.logo_file.rawFile instanceof File)) {
				return Promise.reject('Error: Not a file...');
			}

			const formData = new FormData();
			Object.keys(params.data).forEach(key => {
				if (key === 'logo_file' && params.data.logo_file) {
					formData.append('logo_file', params.data.logo_file.rawFile);
				}
				else if (key === 'translations' && params.data.translations) {
					formData.append('translations', JSON.stringify(params.data.translations));
				}
				else if (params.data[key]) {
					if (Array.isArray(params.data[key])) {
						params.data[key].forEach((id) => {
							formData.append(key, id);
						});
					}
					else {
						formData.append(key, params.data[key]);
					}
				}
			});

			let url = `${API_URL}/partners`;
			if (type === 'UPDATE') {
				url += `/${params.id}`;
			}

			return axios.post(url, formData, {
				headers: {
					'content-type': 'multipart/form-data'
				}
			});
		}
	}

	return requestHandler(type, resource, params);
};
